
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { hasValueChanged, fieldValueToString } from "./Common.js";
import { join, isNullOrWhiteSpace } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { append, filter, ofArray, empty, toArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InfiniteTable } from "../../../Widgets/Table/InfiniteTable.js";
import { singleton, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TabsMenu } from "../../../Widgets/TabsMenu.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";

function validationModalColumns(t) {
    return [new ColumnDefinition$1("fieldName", "", t("updater.validation_row_modal.table_fields.field_name"), (fv) => (new CellContent(0, [t(fv.FieldNameTranslationKey)])), "text", "text"), new ColumnDefinition$1("oldValue", "", t("updater.validation_row_modal.table_fields.old_value"), (fv_1) => (new CellContent(0, [fieldValueToString(t, fv_1.OldValue)])), "text", "text"), new ColumnDefinition$1("newValue", "", t("updater.validation_row_modal.table_fields.new_value"), (fv_3) => {
        const newVal = fieldValueToString(t, fv_3.NewValue);
        return new CellContent(0, [!isNullOrWhiteSpace(newVal) ? newVal : (!isNullOrWhiteSpace(fv_3.NewRaw) ? fv_3.NewRaw : "")]);
    }, "text", "text"), new ColumnDefinition$1("error", "", t("updater.validation_row_modal.table_fields.error"), (fv_4) => {
        const matchValue = fv_4.Error;
        let matchResult, err_1;
        if (matchValue != null) {
            if (!isNullOrWhiteSpace(matchValue.Error)) {
                matchResult = 0;
                err_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new CellContent(0, [t(err_1.Error)]);
            default:
                return new CellContent(0, [""]);
        }
    }, "text", "text"), new ColumnDefinition$1("additionalInfo", "", t("updater.validation_row_modal.table_fields.hint"), (fv_5) => {
        const matchValue_1 = fv_5.Error;
        let matchResult_1, err_3;
        if (matchValue_1 != null) {
            if (!isNullOrWhiteSpace(matchValue_1.AdditionalInfo)) {
                matchResult_1 = 0;
                err_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0:
                return new CellContent(0, [t(err_3.AdditionalInfo)]);
            default:
                return new CellContent(0, [""]);
        }
    }, "text", "text")];
}

function FieldValidationTable(props) {
    let elems;
    const t = useTranslation()[0];
    let fieldsArray;
    const dependencies_1 = [props.Fields];
    fieldsArray = reactApi.useMemo(() => toArray(props.Fields), dependencies_1);
    let columns;
    const dependencies_1_1 = [t];
    columns = reactApi.useMemo(() => validationModalColumns(t), dependencies_1_1);
    if (fieldsArray.length === 0) {
        return reactElement("div", {});
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden", "mt-4"])], (elems = [createElement(InfiniteTable, {
            ColumnDefinitions: columns,
            Controls: empty(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["fieldName", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
                WithQueryParameters: false,
            },
            TableKey: props.TableKey,
            TableRows: fieldsArray,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function InvalidOrChangedView(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(FieldValidationTable, {
        Fields: props.Fields,
        TableKey: "invalid-or-changed-fields-table",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function UnchangedView(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(FieldValidationTable, {
        Fields: props.Fields,
        TableKey: "unchanged-fields-table",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Content(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsUnchangedFieldsVisible = patternInput_1[1];
    const isUnchangedFieldsVisible = patternInput_1[0];
    const invalidFields = filter((f) => !f.IsValid, props.RowValidation.Fields);
    const changedFields = filter((f_1) => {
        if (f_1.IsValid) {
            return hasValueChanged(t, f_1);
        }
        else {
            return false;
        }
    }, props.RowValidation.Fields);
    const unchangedFields = filter((f_2) => {
        if (f_2.IsValid) {
            return !hasValueChanged(t, f_2);
        }
        else {
            return false;
        }
    }, props.RowValidation.Fields);
    const invalidOrChangedFields = append(invalidFields, changedFields);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = toList(delay(() => append_1(singleton(createElement(TabsMenu, {
        Tabs: ofArray([{
            IsSelected: !isUnchangedFieldsVisible,
            Label: t("updater.validation_row_modal.changed_or_invalid_title"),
            OnClick: () => {
                setIsUnchangedFieldsVisible(false);
            },
            TestId: "validation-row-modal-tab-changed",
        }, {
            IsSelected: isUnchangedFieldsVisible,
            Label: t("updater.validation_row_modal.unchanged_title"),
            OnClick: () => {
                setIsUnchangedFieldsVisible(true);
            },
            TestId: "validation-row-modal-tab-unchanged",
        }]),
    })), delay(() => (isUnchangedFieldsVisible ? singleton(createElement(UnchangedView, {
        Fields: unchangedFields,
    })) : singleton(createElement(InvalidOrChangedView, {
        Fields: invalidOrChangedFields,
    }))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ValidationRowModal(props) {
    let elems;
    return createElement(ModalSheet, {
        CloseButtonTestId: "validation-modal-close",
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col", "w-full", "mx-auto", "p-6"])], (elems = [createElement(Content, {
            RowValidation: props.RowValidation,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    });
}

